__turbopack_export_value__({
  "body-logo-18": "contactsHeader-module-scss-module__VoawQa__body-logo-18",
  "body-text-12": "contactsHeader-module-scss-module__VoawQa__body-text-12",
  "body-text-14": "contactsHeader-module-scss-module__VoawQa__body-text-14",
  "body-text-16": "contactsHeader-module-scss-module__VoawQa__body-text-16",
  "body-text-18": "contactsHeader-module-scss-module__VoawQa__body-text-18",
  "body-text-20": "contactsHeader-module-scss-module__VoawQa__body-text-20",
  "body-text-24": "contactsHeader-module-scss-module__VoawQa__body-text-24",
  "body-text-24-2": "contactsHeader-module-scss-module__VoawQa__body-text-24-2",
  "body-text-heading-2": "contactsHeader-module-scss-module__VoawQa__body-text-heading-2",
  "body-text-heading-3": "contactsHeader-module-scss-module__VoawQa__body-text-heading-3",
  "body-text-medium-14": "contactsHeader-module-scss-module__VoawQa__body-text-medium-14",
  "body-text-medium-16": "contactsHeader-module-scss-module__VoawQa__body-text-medium-16",
  "body-text-medium-18": "contactsHeader-module-scss-module__VoawQa__body-text-medium-18",
  "body-text-medium2-18": "contactsHeader-module-scss-module__VoawQa__body-text-medium2-18",
  "body-text2-14": "contactsHeader-module-scss-module__VoawQa__body-text2-14",
  "body-text2-16": "contactsHeader-module-scss-module__VoawQa__body-text2-16",
  "button-primary-text": "contactsHeader-module-scss-module__VoawQa__button-primary-text",
  "button-text": "contactsHeader-module-scss-module__VoawQa__button-text",
  "button2-text": "contactsHeader-module-scss-module__VoawQa__button2-text",
  "buttonsContainer": "contactsHeader-module-scss-module__VoawQa__buttonsContainer",
  "calendar": "contactsHeader-module-scss-module__VoawQa__calendar",
  "card-shadow": "contactsHeader-module-scss-module__VoawQa__card-shadow",
  "contactsHeader": "contactsHeader-module-scss-module__VoawQa__contactsHeader",
  "disabled": "contactsHeader-module-scss-module__VoawQa__disabled",
  "effect-menu": "contactsHeader-module-scss-module__VoawQa__effect-menu",
  "header-1": "contactsHeader-module-scss-module__VoawQa__header-1",
  "link": "contactsHeader-module-scss-module__VoawQa__link",
  "main-container": "contactsHeader-module-scss-module__VoawQa__main-container",
  "main-footer-container": "contactsHeader-module-scss-module__VoawQa__main-footer-container",
  "main-header-container": "contactsHeader-module-scss-module__VoawQa__main-header-container",
  "modal": "contactsHeader-module-scss-module__VoawQa__modal",
  "subtitle": "contactsHeader-module-scss-module__VoawQa__subtitle",
  "title": "contactsHeader-module-scss-module__VoawQa__title",
  "txt-12-bold": "contactsHeader-module-scss-module__VoawQa__txt-12-bold",
  "txt-14-bold": "contactsHeader-module-scss-module__VoawQa__txt-14-bold",
  "txt-14-bold-caps": "contactsHeader-module-scss-module__VoawQa__txt-14-bold-caps",
  "txt-14-med": "contactsHeader-module-scss-module__VoawQa__txt-14-med",
  "txt-16-bold": "contactsHeader-module-scss-module__VoawQa__txt-16-bold",
  "txt-16-med": "contactsHeader-module-scss-module__VoawQa__txt-16-med",
  "txt-18-bold": "contactsHeader-module-scss-module__VoawQa__txt-18-bold",
  "txt-18-medium": "contactsHeader-module-scss-module__VoawQa__txt-18-medium",
  "txt-18-medium-24": "contactsHeader-module-scss-module__VoawQa__txt-18-medium-24",
  "txt-24-semi": "contactsHeader-module-scss-module__VoawQa__txt-24-semi",
});
